
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import axios from 'axios'
import { WrongAnswerNoteOVO } from '@/views/biz/note/vo/WrongAnswerNote.vo'
import { ComboChartVO } from '@/components/vo/Chart.vo'
import PieChart from '@/components/PieChart.vue'
import ComboChart from '@/components/ComboChart.vue'

@Component({
  components: {PieChart, ComboChart }
})
export default class ChartAnalysisDialog extends Vue {
  @Prop() chartAnalysisDialog !: boolean;
  @Prop() emNo !: string;

  // 오답노트 
  wrongAnswerNotes: Array<WrongAnswerNoteOVO> = [] as Array<WrongAnswerNoteOVO>;

  // 차트 데이터 생성
  get lineChartDatasets(): ComboChartVO {
    const result: ComboChartVO = {} as ComboChartVO;

    const labels = [] as Array<string>;
    const crtAnswersLineDatasets = {
        type: 'line'
      , label: '성적 추이'
      , borderColor: '#41B883'
      , borderWidth: '3'
      , fill: false
      , data: [] as Array<number>
    };

    const crtAnswersDatasets = {
        type: 'bar'
      , label: '정답'
      , backgroundColor: 'rgb(0 178 210)'
      , borderColor: 'rgb(0 178 210)'
      , borderWidth: '1'
      , fill: false
      , data: [] as Array<number>
    };

    const wrongAnswersDatasets = {
        type: 'bar'
      , label: '오답'
      , backgroundColor: '#E46651'
      , borderColor: '#E46651'
      , borderWidth: '1'
      , fill: false
      , data: [] as Array<number>
    };
    this.wrongAnswerNotes.forEach(v => {
      labels.push(v.regDt);
      crtAnswersDatasets.data.push(v.crtAnsrCnt as number);
      crtAnswersLineDatasets.data.push(v.crtAnsrCnt as number);
      wrongAnswersDatasets.data.push(Math.abs(v.totalCnt - v.crtAnsrCnt));
    })

    result.labels = labels;
    const datasets = [] as Array<object>;
    datasets.push(crtAnswersLineDatasets);
    datasets.push(crtAnswersDatasets);
    datasets.push(wrongAnswersDatasets);

    result.datasets = datasets;

    return result;
  }

  getWindowSize(){
    switch (this.$vuetify.breakpoint.name) {
      case 'xs': return 220
      case 'sm': return 400
      case 'md': return 500
      case 'lg': return 600
      case 'xl': return 800
    }
  }

  closeDialog(): void {
    this.$store.dispatch(`chartAnalysis/closeModal`, {name: 'chartAnalysis'});
  }

  outsideClickEventHandler() {
    this.closeDialog();
  }

  escKeyDownEventHandler(e) {
    if(e.keyCode != 27) {
      return;
    }
    this.closeDialog();
  }

  @Watch('chartAnalysisDialog')
  init(): void {
    if(this.chartAnalysisDialog == false) return; 

  }

  created(): void {
    axios.get(`/wrong-answer-note/analysis/chart/${this.emNo}`)
    .then(r => {
      this.wrongAnswerNotes = r.data;
    })
  }

}
